import { lang } from 'utils/helpers'
import './styles.scss'
import React from 'react'
// import { getStaticImage } from 'utils/statics'

const ChannelAppPreview = (props) => {
  const { channel, primaryColor } = props

  return (
    <div className={`rectangle chatweb ${channel}`}>
      <div className='image'>
        {/* <img src={`${getStaticImage(`/image-preview.png`)}`} alt='Image preview'/> */}
        <img src='https://cdn.geekwire.com/wp-content/uploads/2018/02/180205-sep-630x382.jpg' alt='App preview'/>
      </div>
      <div className='inner'>
        <p>{lang('dashboard_test-text')}...</p>
      </div>
      <div className='inner-buttons'>
        <div className='buttons' style={primaryColor && { backgroundColor: primaryColor }}>
          <span>{lang('dashboard_button')} 1</span>
        </div>
        <div className='buttons' style={primaryColor && { backgroundColor: primaryColor }}>
          <span>{lang('dashboard_button')} 2</span>
        </div>
      </div>
    </div>
  )
}

export default ChannelAppPreview
